module.exports = __webpack_public_path__ + "img/read_icon.6127cab9.svg";